import React from "react";
import { Helmet } from "react-helmet";
import Img from "../../components/images/img4.jpeg";
import "../../page-layout.css";
import "./biografija.css";

const specialties = [
  "Personalni treninzi",
  "Plan ishrane",
  "Grupni programi",
  "Gubitak kilograma",
  "Oblikovanje tela",
  "Oporavak od povreda",
  "Mišićna masa",
  "Funkcionalni treninzi",
];

const certificates = [
  "Kurs za personalnog trenera",
  "Kurs prve pomoći",
  "Kurs za spasioca na vodi",
];

function Biografija() {
  return (
    <div className="page-wrap">
      <Helmet>
        <title>Biografija | Mihailo Živanović</title>
        <meta
          name="description"
          content="Profesor sporta i fizičkog vaspitanja. Posvećen, ambiciozan i predan trener sa višegodišnjim iskustvom."
        />
      </Helmet>

      <div className="page-hero">
        <div className="page-hero-inner">
          <div className="page-hero-eyebrow">O meni</div>
          <h1 className="page-hero-title">BIOGRAFIJA</h1>
          <p className="page-hero-desc">
            Profesor sporta i fizičkog vaspitanja. Ambiciozan, posvećen i predan —
            trudim se da se svaki klijent oseća motivisano i ugodno.
          </p>
        </div>
      </div>

      <div className="bio-content">
        <div className="bio-inner">
          <div className="bio-left">
            <div className="bio-img-wrap">
              <img src={Img} alt="Mihailo Živanović" />
            </div>
            <div className="bio-contact-card">
              <span className="bio-contact-label">Kontakt</span>
              <a href="tel:+381600737363">+381 60 073 7363</a>
              <a href="mailto:info@mihailo-fitness.rs">info@mihailo-fitness.rs</a>
              <a href="/kontakt/" className="bio-cta-btn">Zakaži trening</a>
            </div>
          </div>

          <div className="bio-right">
            <div className="bio-name-row">
              <h2 className="bio-name">Mihailo Živanović</h2>
              <span className="bio-badge">Profesor sporta i fiz. vaspitanja</span>
            </div>

            <p className="bio-intro">
              Sa 8 godina počeo sam da treniram rukomet. Do svoje 22. godine bavio
              sam se profesionalno rukometom, igrajući za Metaloplastiku u
              regionalnoj Seha ligi. Volim sport i zdrave životne navike.
            </p>
            <p className="bio-intro">
              Pričinjava mi veliko zadovoljstvo da pomažem ljudima u prenošenju
              svog znanja i iskustva. Trudim se da se svaki naš član oseća ugodno,
              vedro i motivisano, kako tokom tako i nakon svakog treninga.
            </p>

            <div className="bio-moto">
              <span className="bio-moto-label">Životni moto</span>
              <blockquote>"SVAKOG DANA IZVUĆI SVOJ MAKSIMUM"</blockquote>
            </div>

            <div className="bio-section">
              <h3 className="bio-section-title">Specijalnost</h3>
              <div className="bio-tags">
                {specialties.map((s) => (
                  <span key={s} className="bio-tag">{s}</span>
                ))}
              </div>
            </div>

            <div className="bio-section">
              <h3 className="bio-section-title">Sertifikati</h3>
              <ul className="bio-cert-list">
                {certificates.map((c) => (
                  <li key={c}>
                    <span className="bio-cert-dot" />
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Biografija;
